import { MaintenanceListTableFullData } from '@/components/sections/service/maintenance-list/table/full';
import {
  MaintenanceCostKey,
  MaintenancePartGroupsKey,
} from '@/types/services/contentstack/services/maintenance-service';
import { IIcon } from '@/types/shared';

export enum SelectOptionStep {
  Type,
  Model,
  Year,
  Schedule,
}

export const CONTENT_FILTER_SELECTS: {
  key: string;
  placeholder: string;
}[] = [];
CONTENT_FILTER_SELECTS[SelectOptionStep.Type] = {
  key: 'type',
  placeholder: 'ประเภทรถ',
};
CONTENT_FILTER_SELECTS[SelectOptionStep.Model] = {
  key: 'model',
  placeholder: 'รุ่นรถ',
};
CONTENT_FILTER_SELECTS[SelectOptionStep.Year] = {
  key: 'year',
  placeholder: 'รุ่นปี',
};
CONTENT_FILTER_SELECTS[SelectOptionStep.Schedule] = {
  key: 'schedule',
  placeholder: 'ระยะเวลาหรือระยะทาง',
};

export const INITIAL_SELECT_OPTION_VALUES = ['', '', '', ''];

const MAINTENANCE_TITLE: { [key: string]: string } = {
  [MaintenancePartGroupsKey.General]: 'ตรวจเช็กสภาพทั่วไป',
  [MaintenanceCostKey.CostBeforeVat]: 'ค่าใช้จ่ายรวมค่าแรงแบบเหมา',
  [MaintenanceCostKey.Discount]: 'คูปองส่วนลด',
  [MaintenanceCostKey.TotalCostWithVat]: 'ค่าใช้จ่ายรวมภาษีมูลค่าเพิ่ม',
};
const MAINTENANCE_ICON: { [key: string]: IIcon } = {
  [MaintenancePartGroupsKey.General]: 'assignment',
  [MaintenanceCostKey.CostBeforeVat]: 'fix',
  [MaintenanceCostKey.Discount]: 'gift-reward',
  [MaintenanceCostKey.TotalCostWithVat]: 'money',
};

const TABLE_VALUE_CELL_WIDTH = '90px';
const TABLE_SCROLL_BAR_SIZE = '8px';

export const TABLE_FULL_DATA: MaintenanceListTableFullData = {
  generalIcon: MAINTENANCE_ICON[MaintenancePartGroupsKey.General],
  generalTitle: MAINTENANCE_TITLE[MaintenancePartGroupsKey.General],
  headerLabelTitle: 'รายการเปลี่ยนถ่าย',
  headerLengthTitle:
    'ระยะทาง (กม.) / ระยะเวลา (เดือน) แล้วแต่อย่างใดอย่างหนึ่งจะถึงก่อน',
  tableCellWidth: TABLE_VALUE_CELL_WIDTH,
  tableScrollBarSize: TABLE_SCROLL_BAR_SIZE,
};

export const PRICE_DATA = {
  costBeforeVatTitle: MAINTENANCE_TITLE[MaintenanceCostKey.CostBeforeVat],
  discountTitle: MAINTENANCE_TITLE[MaintenanceCostKey.Discount],
  totalCostWithVatTitle: MAINTENANCE_TITLE[MaintenanceCostKey.TotalCostWithVat],
  costBeforeVatIcon: MAINTENANCE_ICON[MaintenanceCostKey.CostBeforeVat],
  discountIcon: MAINTENANCE_ICON[MaintenanceCostKey.Discount],
  totalCostWithVatIcon: MAINTENANCE_ICON[MaintenanceCostKey.TotalCostWithVat],
};

export const DEFAULT_TITLE = 'รายการบำรุงรักษา<span>ตามระยะ</span>';
export const DEFAULT_DESCRIPTION =
  'ค้นหารายการบำรุงรักษา<span>ตามระยะของคุณ</span>';
export const DEFAULT_MOBLE_BG =
  'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt4d7ea17802792f9d/61cc79b54376c54ccd7d0517/bg-m.jpg';
export const DEFAULT_DESKTOP_BG =
  'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt13dddfe9b3c1849e/61cc79b556212257cdb4fac7/bg.jpg';

enum MaintenanceListTruckTypeKey {
  TRUCK_4_WHEELS = 'truck-4-wheels',
  TRUCK_6_WHEELS_MIDDLE = 'truck-6-wheels-middle',
  TRUCK_6_WHEELS_LARGE = 'truck-6-wheels-large',
  TRUCK_10_WHEELS_1_AXLE = 'truck-10-wheels-1-axle',
  TRUCK_10_WHEELS_2_AXLE = 'truck-10-wheels-2-axle',
  TRUCK_12_WHEELS = 'truck-12-wheels',
  TRUCK_TRACTOR = 'truck-tractor',
  TRUCK_MIXER = 'truck-mixer',
  TRUCK_MINIBUS_CHASSIS = 'truck-minibus-chassis',
}

export const CONTENTSTACK_CV_TYPE_TO_CUSTOM_NAME_TYPE = {
  'รถบรรทุก 4 ล้อ': MaintenanceListTruckTypeKey.TRUCK_4_WHEELS,
  // currently Contentstack has no space I add space case just in case for now
  'รถ 6 ล้อขนาดกลาง': MaintenanceListTruckTypeKey.TRUCK_6_WHEELS_MIDDLE,
  'รถ 6 ล้อ ขนาดกลาง': MaintenanceListTruckTypeKey.TRUCK_6_WHEELS_MIDDLE,
  'รถ 6 ล้อ ขนาดใหญ่': MaintenanceListTruckTypeKey.TRUCK_6_WHEELS_LARGE,
  'รถ 10 ล้อ เพลาเดียว': MaintenanceListTruckTypeKey.TRUCK_10_WHEELS_1_AXLE,
  'รถ 10 ล้อ 2 เพลา': MaintenanceListTruckTypeKey.TRUCK_10_WHEELS_2_AXLE,
  'รถ 12 ล้อ': MaintenanceListTruckTypeKey.TRUCK_12_WHEELS,
  หัวลาก: MaintenanceListTruckTypeKey.TRUCK_TRACTOR,
  'รถผสมปูน (Mixer)': MaintenanceListTruckTypeKey.TRUCK_MIXER,
  'มินิบัส แชสชีส์': MaintenanceListTruckTypeKey.TRUCK_MINIBUS_CHASSIS,
  'มินิบัส แชสซีส์': MaintenanceListTruckTypeKey.TRUCK_MINIBUS_CHASSIS,
};
export const CUSTOM_NAME_TYPE_TO_CONTENTSTACK_CV_TYPE = {
  [MaintenanceListTruckTypeKey.TRUCK_4_WHEELS]: 'รถบรรทุก 4 ล้อ',
  [MaintenanceListTruckTypeKey.TRUCK_6_WHEELS_MIDDLE]: 'รถ 6 ล้อขนาดกลาง',
  [MaintenanceListTruckTypeKey.TRUCK_6_WHEELS_MIDDLE + '_2']:
    'รถ 6 ล้อ ขนาดกลาง',
  [MaintenanceListTruckTypeKey.TRUCK_6_WHEELS_LARGE]: 'รถ 6 ล้อ ขนาดใหญ่',
  [MaintenanceListTruckTypeKey.TRUCK_10_WHEELS_1_AXLE]: 'รถ 10 ล้อ เพลาเดียว',
  [MaintenanceListTruckTypeKey.TRUCK_10_WHEELS_2_AXLE]: 'รถ 10 ล้อ 2 เพลา',
  [MaintenanceListTruckTypeKey.TRUCK_12_WHEELS]: 'รถ 12 ล้อ',
  [MaintenanceListTruckTypeKey.TRUCK_TRACTOR]: 'หัวลาก',
  [MaintenanceListTruckTypeKey.TRUCK_MIXER]: 'รถผสมปูน (Mixer)',
  [MaintenanceListTruckTypeKey.TRUCK_MINIBUS_CHASSIS]: 'แชสชีส์',
  [MaintenanceListTruckTypeKey.TRUCK_MINIBUS_CHASSIS + '_2']: 'แชสซีส์',
};

export const DEFAULT_CV_VEHICLE_IMAGE =
  'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltcfbf21330f059331/626563ab0796ef5b6c344805/cv-compare-default.png?format=pjpg&auto=webp&width=320&quality=85';

export const CUSTOM_CV_MODEL_IMAGE_MAP = {
  'truck-mixer_frrmixereuro5':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blteb5bacb77897b4ab/65e992830395e480622852de/euro-5-frr-mixer.png',
  'truck-mixer_nmrmixereuro5':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blte615cb7c431794de/65e994ba6f950c4ab98c73a0/euro-5-nmr-mixer.png',
  'truck-tractor_ftreuro5':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltfd45ba711889aac2/677e22d47dbc196704f9cba7/euro-5-ftr-tractor.png',
  'truck-tractor_gxzeuro5':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltced435a6ddc38624/677e20db27dd6e595942d36c/euro-5-gxz.png',
  'truck-tractor_gxzabseuro5':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltced435a6ddc38624/677e20db27dd6e595942d36c/euro-5-gxz.png',
  'truck-12-wheels_fyheuro5':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt409b93c20c86f1ae/65e99459a8b011da8d5c7baf/euro-5-fyh.png',
  'truck-10-wheels-2-axle_fvz-seuro5':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt505777f00190c72a/65e99412ed37f64cb3b10f1a/euro-5-fvz-s.png',
  'truck-10-wheels-2-axle_fvzeuro5':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltd3339d1c258bec9b/65e99429c61144e26f92502d/euro-5-fvz.png',
  'truck-10-wheels-2-axle_fxzeuro5':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltba9f8af053e942ff/65e99441504e03b14df1c1f8/euro-5-fxz.png',
  'truck-10-wheels-1-axle_fvmfvmiesceuro5':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt71790cb9951f5b58/65e993ae1ab2dc6aff97a630/euro-5-fvm-iesc.png',
  'truck-10-wheels-1-axle_fvmiesceuro5':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt71790cb9951f5b58/65e993ae1ab2dc6aff97a630/euro-5-fvm-iesc.png',
  'truck-10-wheels-1-axle_fvm-seuro5':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt9ca2d04c599a6495/65e993d0504e031deaf1c1f4/euro-5-fvm-s.png',
  'truck-10-wheels-1-axle_fvmeuro5':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt9116583d3df46231/65e993e7ed466167357887f7/euro-5-fvm.png',
  'truck-6-wheels-large_ftrsmoothereuro5':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt410f1ec3584e83c7/65e9937b7d810a1e8941a742/euro-5-ftr.png',
  'truck-6-wheels-large_ftreuro5':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt410f1ec3584e83c7/65e9937b7d810a1e8941a742/euro-5-ftr.png',
  'truck-6-wheels-middle_frr-seuro5':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt20f888d82202ca9d/65e993187756f65aaff6404a/euro-5-frr-s.png',
  'truck-6-wheels-middle_frreuro5':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blte2f270525c19d4b7/65e9934c63ec4202625d8e8d/euro-5-frr.png',
  'truck-6-wheels-middle_nqreuro5':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt87314fe2d2718ec0/65e9955d63ec427c785d8e9e/euro-5-nqr.png',
  'truck-6-wheels-middle_nprsmoothereuro5':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt672619903733e682/65e9951203e460c5c1dc3e6c/euro-5-npr.png',
  'truck-6-wheels-middle_npreuro5':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt672619903733e682/65e9951203e460c5c1dc3e6c/euro-5-npr.png',
  'truck-6-wheels-middle_nmr6euro5':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt4704902cc654f1ad/65e994d1ed46613357788802/euro-5-nmr.png',
  'truck-6-wheels-middle_nmr5euro5':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt4704902cc654f1ad/65e994d1ed46613357788802/euro-5-nmr.png',
  'truck-4-wheels_nlrsmoothereuro5':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltbb19b36db3558045/65e994a26f950cf1eb8c739e/euro-5-nlr.png',
  'truck-4-wheels_nlreuro5':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltbb19b36db3558045/65e994a26f950cf1eb8c739e/euro-5-nlr.png',
  'truck-mixer_fxzmixer':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltac75874634418977/631014067cb46356cd3a8daa/fxz-320-2022-mixer.png',
  'truck-mixer_frrmixer':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt8e99106c4295d705/61f12470b870e6280280078b/frr-mixer-190-center.png',
  'truck-mixer_nmrmixer':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltb6fbe408440c25fc/62a2b2a734f22956975fa7be/ELF_MIXER.png',
  'truck-minibus-chassis_npr150minibuschassis':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt9fb132d474a95d08/61f125cb12244c25ceb6df5b/npr-mini-bus-chassis.png',
  'truck-tractor_gxz360':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blte34120d73bb2a768/677e233198b8d10037afdf3f/euro-3-gxz.png',
  'truck-tractor_gxztherockgxziesc':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blte34120d73bb2a768/677e233198b8d10037afdf3f/euro-3-gxz.png',
  'truck-tractor_gxz345':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt3070a56a0d1aae10/67808931532fd620cc5a15d8/euro-3-gxz-the-rock.png',
  'truck-12-wheels_fyh360':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt813c0b809fc79ba5/627e20683b9b85549049a0f6/FYH.png',
  'truck-10-wheels-2-axle_fvz300':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltf114003ca9fb7c3c/62467dba71dd7f0f223e8eb9/fvz-300-240-center.png',
  'truck-10-wheels-2-axle_fvz240':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltdce87fa2787ddfa9/61f12504a4c49a2752822e29/fvz-300-240-center.png',
  'truck-10-wheels-2-axle_fxz360':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt562c0d77ac9009ad/627e214d045749535846c44d/FXZ.png',
  'truck-10-wheels-2-axle_fxztherock':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt35e1348461ded9e7/65f92205f50f9a0a267c162f/euro-3-fxz-the-rock.png',
  'truck-10-wheels-2-axle_fxz345':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt562c0d77ac9009ad/627e214d045749535846c44d/FXZ.png',
  'truck-10-wheels-1-axle_fvm300':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt9ce295c0050d33e3/61f124f2031a18274b668742/fvm-300-240-center.png',
  'truck-10-wheels-1-axle_fvm240':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt9ce295c0050d33e3/61f124f2031a18274b668742/fvm-300-240-center.png',
  'truck-6-wheels-large_ftr240smoother':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blta21a4f90697f6b64/61f1248f5874d72782979f75/ftr-240-center.png',
  'truck-6-wheels-large_ftr240':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blta21a4f90697f6b64/61f1248f5874d72782979f75/ftr-240-center.png',
  'truck-6-wheels-middle_frr210':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt530ee3aee43e5a79/61f123973a862229877318d8/frr-210-190-center.png',
  'truck-6-wheels-middle_frr190':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt530ee3aee43e5a79/61f123973a862229877318d8/frr-210-190-center.png',
  'truck-6-wheels-middle_nqr175':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltbe527a12d3c60b47/62afebea682a22504d4e752a/NQR_175_revise.png',
  'truck-6-wheels-middle_npr150smoother':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltf4aea09b80464548/62afebcc92725d5bf8180c16/NPR_150_revise.png',
  'truck-6-wheels-middle_npr150':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltf4aea09b80464548/62afebcc92725d5bf8180c16/NPR_150_revise.png',
  'truck-6-wheels-middle_nmr1306':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt6e6edd6003f16658/62afeb8b05f1d157f3a8c1fd/NMR_130_revise.png',
  'truck-6-wheels-middle_nmr1305':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt6e6edd6003f16658/62afeb8b05f1d157f3a8c1fd/NMR_130_revise.png',
  'truck-4-wheels_nlr130smoother':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt3161e5590abc1d9e/62a2b190b53bb658a3925253/NLR_130.png',
  'truck-4-wheels_nlr130':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt3161e5590abc1d9e/62a2b190b53bb658a3925253/NLR_130.png',
  'truck-4-wheels_nlrlite':
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltcf3df59bc8d25ee6/65e95558c9226cb4efe85e46/euro-3-nlr-lite.png',
};

export const CUSTOM_MAP_MAINTAIN_OLD_CV_MODEL_QUERY = {
  'nmr-130-5-speed': 'nmr1305',
  'nmr-130-6-speed': 'nmr1306',
  'fxz-mixer-320': 'fxzmixer',
  'frr-mixer-190': 'frrmixer',
  'gxz-the-rock': 'gxztherockgxziesc',
  'gxz-iesc': 'gxztherockgxziesc',
};

/**
 * Internal note for maintaining previous URL query
 */
// const OLD_CV_MODELS = [
//   'nlr-lite',
//   'nlr-130',
//   'nlr-130-smoother',
//   'frr-190',
//   'frr-210',
//   'nmr-130-5-speed',
//   'nmr-130-6-speed',
//   'npr-150',
//   'npr-150-smoother',
//   'nqr-175',
//   'ftr-240',
//   'ftr-240-smoother',
//   'fvm-240',
//   'fvm-300',
//   'fxz-345',
//   'fxz-the-rock',
//   'fxz-360',
//   'fvz-240',
//   'fvz-300',
//   'fyh-360',
//   'gxz-345',
//   'gxz-the-rock',
//   'gxz-iesc',
//   'gxz-360',
//   'fxz-mixer-320',
//   'frr-mixer-190',
//   'nmr-mixer-130',
//   'npr-150-mini-bus-chassis',
// ];
// const CURRENT_POSSIBLE_URLS = [
//   'frrmixereuro5_2024',
//   'nmrmixereuro5_2024',
//   'ftreuro5_2024',
//   'gxzeuro5_2024',
//   'gxzabseuro5_2024',
//   'fyheuro5_2024',
//   'fvz-seuro5_2024',
//   'fvzeuro5_2024',
//   'fxzeuro5_2024',
//   'fvmiesceuro5_2024',
//   'fvm-seuro5_2024',
//   'fvmeuro5_2024',
//   'ftrsmoothereuro5_2024',
//   'ftreuro5_2024',
//   'frr-seuro5_2024',
//   'frreuro5_2024',
//   'nqreuro5_2024',
//   'nprsmoothereuro5_2024',
//   'npreuro5_2024',
//   'nmr6euro5_2024',
//   'nmr5euro5_2024',
//   'nlrsmoothereuro5_2024',
//   'nlreuro5_2024',
//   'fxzmixer_2022',
//   'fxzmixer_2020',
//   'frrmixer_2022',
//   'frrmixer_2020',
//   'nmrmixer_2022',
//   'nmrmixer_2020',
//   'npr150minibuschassis_2022',
//   'npr150minibuschassis_2020',
//   'gxz360_2022',
//   'gxz360_2020',
//   'gxztherockgxziesc_2022',
//   'gxz345_2020',
//   'fyh360_2022',
//   'fyh360_2020',
//   'fvz300_2022',
//   'fvz300_2020',
//   'fvz240_2022',
//   'fvz240_2020',
//   'fxz360_2022',
//   'fxz360_2020',
//   'fxztherock_2022',
//   'fxz345_2020',
//   'fvm300_2022',
//   'fvm300_2020',
//   'fvm240_2022',
//   'fvm240_2020',
//   'ftr240smoother_2022',
//   'ftr240smoother_2020',
//   'ftr240_2022',
//   'ftr240_2020',
//   'frr210_2022',
//   'frr210_2020',
//   'frr190_2022',
//   'frr190_2020',
//   'nqr175_2022',
//   'nqr175_2020',
//   'npr150smoother_2022',
//   'npr150smoother_2020',
//   'npr150_2022',
//   'npr150_2020',
//   'nmr1306_2022',
//   'nmr1306_2020',
//   'nmr1305_2022',
//   'nmr1305_2020',
//   'nlr130smoother_2022',
//   'nlr130_2022',
//   'nlr130_2020',
//   'nlrlite_2022',
//   'nlrlite_2020',
// ];
